export default "/048cb1f2b29308e18768c65cfd51e426596a830c/2cb37da391587709fd85749e116baa74.svg";